module.exports = "//static.hsappstatic.net/signup-ui-lego/static-1.7799/images/sales-leader-calendar/sales-leader-calendar.png"